import React from 'react';
import {useRoomPlannerLeftMenu} from 'components/customer/RoomPlanner/helper/useRoomPlannerLeftMenu';
import styled from 'styled-components';
import {useRoomPreview} from 'components/customer/RoomPlanner/components/helpers/RoomPreview';
import {SurveyButton} from 'shared/components/Header/RoomPlanner/SurveyButton';
import {TutorialButton} from 'shared/components/Header/RoomPlanner/TutorialButton';
import {KeyboardShortcutsButton} from 'shared/components/Header/RoomPlanner/KeyboardShortcutsButton';
import ShareButton from 'shared/components/Header/ShareButton';
import {useAppSelector} from 'store/customer';
import {getHasWebGLError} from 'components/customer/Preview3DCommon/store/viewerSlice';

export const Desktop = () => {
    const {isRoomPlannerPage} = useRoomPlannerLeftMenu();
    const hasWebGLError = useAppSelector(getHasWebGLError);
    const isRoomPreview = useRoomPreview();

    if (!isRoomPlannerPage || isRoomPreview || hasWebGLError) {
        return null;
    }

    return (
        <HelpCluster data-cy="room-planner-floating-toolbar">
            <ShareButton />
            <SurveyButton />
            <TutorialButton />
            <KeyboardShortcutsButton />
        </HelpCluster>
    );
};

const HelpCluster = styled.div`
    position: fixed;
    right: 16px;
    bottom: 48px;
    z-index: 20;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    pointer-events: none;

    & > * {
        pointer-events: auto;
    }

    button {
        margin: 0;
        border-radius: 999px;
        border: 1px solid #e6e8ec;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
    }
`;
